import $ from 'jquery';
import BasketService from '../service/BasketService';
import Api from '../utilities/Api';

if ($('.catalog-detail-info__content').length > 0) {
    if ($('.catalog-detail-purchase').length > 0) {
        (async function () {
            const externalId = $('.catalog-detail-purchase').attr('data-external-id');
            const response = await Api.post('/api/v2/catalog/prices/', {
                products: [externalId]
            });

            if(response.items && !!response.items[externalId]){
                const {
                    price,
                    points
                } = response.items[externalId];
                $('.catalog-detail-purchase__price').text(`${price} `);
                $('.catalog-detail-purchase__points').html(`Баллы: <span>${points}</span>`);
                $('.catalog-detail-purchase').addClass('catalog-detail-purchase--active');
                $('.catalog-item-to-basket').addClass('catalog-item-to-basket--active');
            }
        })();
    } else {
        $('.catalog-detail-subscribe').show();
    }
}

$('.catalog-detail-purchase__button').click(function () {
    if ($(this).hasClass('catalog-detail-purchase__button--active')) {
        window.location = '/basket';
        return;
    }

    $(this).addClass('catalog-detail-purchase__button--active')
        .find('span')
        .text('В корзине');

    BasketService.add(
        $(this).attr('data-product-id'),
        $('.catalog-detail-quantity__value').val()
    ).then(({ count }) => {
        BasketService.updateHeaderCounter(count);
    });
});
